import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./Recipient.module.scss";
import { getDefaultImage } from "../../../utils/GeneralUtils";
import SonicLink from "../../../common/routing/SonicLink";

type Props = {
  children: React.ReactNode;
  type?: string;
  img?: string;
  user_name?: string;
  target_name?: string;
  mail_address?: string;
  link: string;
  isStudent: boolean;
};

const Recipient: React.FC<Props> = (props) => {
  const {
    children,
    type,
    img,
    user_name,
    target_name,
    mail_address,
    link,
    isStudent,
  } = props;

  // TODO: Check performance on this and make sure it doesn't force constant rerenders
  const title: string =
    type === "project" ? "プロジェクト情報" : "オファー対象";
  let target_label: string = "";

  switch (type) {
    // case "student":
    //   title = "オファー対象者";
    //   target_label = "対象プロフィール";
    //   break;
    case "database_entries":
      target_label = "対象プロフィール";
      break;
    case "project":
      target_label = "対象プロジェクト";
      break;

    // teamとcompanyも後で使う予定なので、作っておいてコメントアウト
    // case 'teams':
    //   target_label = "対象チーム";
    //   break;
    // case 'companies':
    //   target_label = "対象企業";
    //   break;
    default:
  }

  return (
    <div className={styles["f-recipient"]}>
      <h2 className={styles["f-recipient__title"]}>{title}</h2>
      <div className={styles["f-recipient__content"]}>
        <img src={img ? img : getDefaultImage()} />
        <div className={styles["f-recipient__content-info"]}>
          <div>
            <p>{target_label}</p>
            <span>{target_name}</span>
          </div>
          <div>
            <p>{isStudent === true ? "学生氏名" : "会員名"}</p>
            <div>
              <span>{user_name}</span>
              {/* TODO Link to membership details page */}
              <SonicLink to={link} newTab={true}>
                <FontAwesomeIcon icon={["fal", "external-link-alt"]} />
                ユーザー詳細
              </SonicLink>
            </div>
          </div>
          <div>
            <p>メールアドレス</p>
            <span>{mail_address}</span>
          </div>
        </div>
      </div>
      {children}
    </div>
  );
};

export default Recipient;
